import { toast } from 'react-toastify';
import appApi from '../../../../api/app-api';
import { displayErrorText } from '../../../../api/errors/api-error-codes';
import { SecurityGroupEntity } from '../../../../api/types/settings/permissions/security-group-entity';

export const getAllSecurityGroupsOperation = async (
  offset: number,
  limit: number,
  setData: (data: SecurityGroupEntity[]) => void,
  setTotal: (total: number) => void,
  setLoading: (loading: boolean) => void,
) => {
  try {
    setLoading(true);

    const res = await appApi.getAllSecurityGroups(offset, limit);

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setData([]);
      setTotal(0);
      return;
    }

    setData(res.data.body?.data ?? []);
    setTotal(res.data.body?.total ?? 0);
  } catch (e) {
    console.error('getAllSecurityGroupsOperation failed:', e);
    //toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
    setData([]);
    setTotal(0);
  } finally {
    setLoading(false);
  }
};
